module.exports = __webpack_public_path__ + "media/images/icons/step-icon-orange-28583767c495087ccc29cb2c823cc1f4.svg";